<template>
  <div class="dashboard-left-card bg-light p-2">
    <div class="text-bold">Belanja Domestik VS Belanja TKDN</div>
    <div style="font-size:10px; font-weight: bold; margin-bottom:10px">
      Dalam Dolar USD
    </div>
    <bar-chart :chartData="chartData" :options="chartOptions" :styles="{ height: '80%' }" v-if="belanjaDomestik" />
  </div>
</template>
<script>
import numeral from 'numeral'
export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
  },
  data() {
    return {
      chartData: {
        labels: ['2020', '2021', '2022'],
        datasets: [
          {
            label: 'Total Belanja Domestik',
            backgroundColor: 'red',
            data: [280, 200, 32],
          },
          {
            label: 'Total TKDN',
            backgroundColor: 'pink',
            data: [144, 100, 16],
          },
          {
            label: 'Total Local Expenditure',
            backgroundColor: 'orange',
            data: [144, 100, 16],
          },
        ],
      },
      chartOptions: {
        showDatapoints: true,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          axis: 'y',
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              // label += Math.round(tooltipItem.yLabel * 100) / 100;
              let idr = numeral(tooltipItem.yLabel).format('0,0.00')
              let newIdr = ''
              idr.split('').map(list => {
                if (list == ',') {
                  newIdr += '.'
                } else if (list == '.') {
                  newIdr += ','
                } else {
                  newIdr += list
                }
              })

              label += newIdr
              return label
            },
          },
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                display: false,
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Nilai Pengadaan',
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Tahun',
              },
            },
          ],
        },
        legend: {
          position: 'bottom',
          labels: {
            fontSize: 10,
            boxWidth: 12,
          },
        },
      },
    }
  },
  computed: {
    belanjaDomestik() {
      let data = this.$store.state.tkdnStore.belanjaDomestik
      this.convertData(data)

      return data
    },
  },
  methods: {
    convertData(data) {
      if (data && data.length > 0) {
        let labels = []
        let belanjaDomestik = []
        let totalTkdn = []
        let expenditur = []

        data.forEach(item => {
          labels.push(item.YEAR)
          belanjaDomestik.push(item.VALUE_LC)
          totalTkdn.push(item.TOTAL_TKDN)
          expenditur.push(item.EXPENDITUR)
        })

        this.chartData = {
          labels: labels,
          datasets: [
            {
              label: 'Total Belanja Domestik',
              backgroundColor: 'red',
              data: belanjaDomestik,
            },
            {
              label: 'Total TKDN',
              backgroundColor: 'pink',
              data: totalTkdn,
            },
            {
              label: 'Total Local Expenditure',
              backgroundColor: 'orange',
              data: expenditur,
            },
          ],
        }
      } else {
        this.chartData = {
          labels: [],
          datasets: [
            {
              label: 'Total Belanja Domestik',
              backgroundColor: 'red',
              data: [],
            },
            {
              label: 'Total TKDN',
              backgroundColor: 'pink',
              data: [],
            },
            {
              label: 'Total Local Expenditure',
              backgroundColor: 'orange',
              data: [],
            },
          ],
        }
      }
    },
  },
}
</script>
